import React from "react";
import styled from "styled-components";

const PHASES = ["Preclinical", "Phase 1", "Phase 2", "Phase 3"];

const Container = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const ColProduct = styled.col`width: 160px;
  ${props => props.theme.media.mobile`width: 100px;`};
`;
const ColPhase = styled.col``;

const Th = styled.th`
  font-size: 1.05rem;
  font-weight: 600;
  color: #6b7280;
  text-align: left;
  padding: 0.85rem 0.65rem;
  border-bottom: 2px solid #e8eaed;
  border-left: 1px solid #e8eaed;
  vertical-align: bottom;

  &:first-child {
    border-left: none;
  }

  ${props => props.theme.media.mobile`
    font-size: 0.94rem;
    padding: 0.6rem;
  `};
`;

const Td = styled.td`
  padding: 0.85rem 0.65rem;
  border-bottom: 1px solid #eff0f1;
  border-left: 1px solid #e8eaed;
  vertical-align: middle;
  height: 76px;

  &:first-child {
    border-left: none;
  }

  ${props => props.theme.media.mobile`
    height: 75px;
    padding: 0.6rem;
  `};
`;

const ProductNameText = styled.div`
  font-size: 1.475rem;
  font-weight: 700;
  color: #005baa;
  line-height: 1.3;

  span {
    display: block;
    font-size: 1.125rem;
    font-weight: 400;
    color: #6b7280;
    margin-top: 0.1rem;
  }

  ${props => props.theme.media.mobile`
    font-size: 1.25rem;
    span { font-size: 1rem; }
  `};
`;


const PhaseTd = styled.td`
  padding: 0;
  border-bottom: 1px solid #eff0f1;
  border-left: 1px solid #e8eaed;
  height: 76px;
  position: relative;
  overflow: visible;

  ${props => props.theme.media.mobile`
    height: 75px;
  `};
`;

const Bar = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  height: 54px;
  background: linear-gradient(90deg, #43bcba 0%, #1a6fb5 60%, #005baa 100%);
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0.9rem;
  z-index: 1;

  ${props => props.theme.media.mobile`
    height: 30px;
    padding-right: 0.5rem;
  `};
`;

const BarLabel = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  white-space: nowrap;

  ${props => props.theme.media.mobile`
    font-size: 0.69rem;
  `};
`;

const Pipeline = ({ products }) => {
  const rows = [];
  products.forEach((product) => {
    product.indications.forEach((indication, j) => {
      rows.push({ product, indication, showName: j === 0, rowSpan: product.indications.length });
    });
  });

  return (
    <Container>
      <StyledTable>
        <colgroup>
          <ColProduct />
          {PHASES.map(p => <ColPhase key={p} />)}
        </colgroup>
        <thead>
          <tr>
            <Th>Candidate</Th>
            {PHASES.map(phase => <Th key={phase}>{phase}</Th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.showName ? (
                <Td rowSpan={row.rowSpan}>
                  <ProductNameText>
                    {row.product.name}
                    {row.product.subtitle && <span>{row.product.subtitle}</span>}
                  </ProductNameText>
                </Td>
              ) : null}
              {PHASES.map((phase, pi) => (
                <PhaseTd key={phase}>
                  {pi === 0 && (
                    <Bar style={{ width: (row.indication.progress / 25 * 100) + "%" }}>
                      <BarLabel>{row.indication.label}</BarLabel>
                    </Bar>
                  )}
                </PhaseTd>
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </Container>
  );
};

Pipeline.defaultProps = {
  products: [
    {
      name: "NES/T",
      subtitle: "hormonal gel",
      indications: [
        {
          disease: "Male Contraception",
          progress: 73,
          label: "Phase 2B Completed",
        },
      ],
    },
    {
      name: "ADAM",
      subtitle: "non-hormonal implant",
      indications: [
        {
          disease: "Male Contraception",
          progress: 48,
          label: "Phase 2 Ready",
        },
      ],
    },
  ],
};

export default Pipeline;



// WEBPACK FOOTER //
// ./src/components/Pipeline.js